import styled from "styled-components";
import { ContainerSection } from "@/main/components/shared/styles";

export const Container = styled(ContainerSection)``;

export const HeaderSection = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 1rem;
`;
